import React, { Component, Fragment } from 'react';
import {loaderSVG} from '../../../assets/images';
import NewGroupProfile from './NewGroupProfile';
import NewParticipants from './NewParticipants';
import PropTypes from 'prop-types';

export default class CreateNewGroup extends Component {
    constructor(props) {
        super(props)
        this.state = {
            profileView: !props.newCall,
            groupProfileImage:'',
            typingMessage:'',
            description: '',
            loading:false
        }
    }

    changeScreen = (groupInfo) => {
        const { typingMessage, groupProfileImage, description, profileImage} = groupInfo
        this.setState(prevState => ({
            profileView: !prevState.profileView,
            loading: true,
            typingMessage: typingMessage || prevState.typingMessage,
            groupProfileImage: profileImage ? groupProfileImage : prevState.groupProfileImage,
            description: description !== undefined ? description : prevState.description,
          }), () => {
            this.setState({ loading: false });
          });
    }

    render() {
        const { handleBackToRecentChat, vCardData } = this.props
        const { profileView,typingMessage, groupProfileImage, description, loading } = this.state
        const style = { width: 50, height: 50 }

        return (
            <Fragment>
                <div className="loader">
                    {loading && <img src={loaderSVG} alt="message-history" style={style} />}
                </div>
                {
                    profileView && <NewGroupProfile
                        handleBackToRecentChat={handleBackToRecentChat}
                        typingMessage={typingMessage}
                        groupProfileImage={groupProfileImage}
                        description={description}
                        handleMoveToPartcipantList={this.changeScreen}
                    />
                }
                {
                    !profileView && <NewParticipants
                        typingMessage={typingMessage}
                        description={description}
                        vCardData={vCardData}
                        groupProfileImage={groupProfileImage}
                        handleBackToGroup={this.changeScreen}
                        handleBackToRecentChat={handleBackToRecentChat}
                        newCall={this.props.newCall}
                        newCallType={this.props.newCallType}
                        handleBackToCallLog={this.props.handleBackFromNewCall}
                        handleMakeNewCall={this.props.handleMakeNewCall}
                    />
                }
            </Fragment>
        )
    }
}

CreateNewGroup.propTypes = {
    handleBackToRecentChat: PropTypes.func,
    vCardData: PropTypes.shape({
        data: PropTypes.object
    })
};